<template>
  <div class="footer-bar" role="contentinfo">
    <div class="footer-content">
      <ul class="footer-column" :aria-labelledby="'footer-heading-op-koti'">
        <li><h3 id="footer-heading-op-koti">OP Koti</h3></li>
        <li><RouterLink to="/" tabindex="0">Myymässä</RouterLink></li>
        <li><RouterLink to="/myytavat" tabindex="0">Ostamassa</RouterLink></li>
        <li><RouterLink to="/vuokraamassa" tabindex="0">Vuokraamassa</RouterLink></li>
      </ul>
      <ul class="footer-column" :aria-labelledby="'footer-heading-palvelut'">
        <li><h3 id="footer-heading-palvelut">Palvelut</h3></li>
        <li><RouterLink :to="apartments" tabindex="0">Kohdehaku</RouterLink></li>
        <li><RouterLink to="/asunnon-hintalaskuri" tabindex="0">Hinta-arviolaskuri</RouterLink></li>
        <li><RouterLink :to="agencies.path" tabindex="0">OP Koti -toimipisteet</RouterLink></li>
        <li><RouterLink :to="liekkiSellersService.path" tabindex="0">Myyjän palvelu</RouterLink></li>
      </ul>
      <ul class="footer-column" :aria-labelledby="'footer-heading-palvelun-tiedot'">
        <li><h3 id="footer-heading-palvelun-tiedot">Palvelun tiedot</h3></li>
        <li><RouterLink :to="staticPage.paths.eula" tabindex="0">Käyttöehdot</RouterLink></li>
        <li>
          <RouterLink :to="staticPage.paths.personalData" tabindex="0"
            >Henkilötietojen käsittely kiinteistönvälityksessä</RouterLink
          >
        </li>
        <li>
          <RouterLink :to="staticPage.paths.personalDataPropertyManagement" tabindex="0">
            Henkilötietojen käsittely isännöinnissä
          </RouterLink>
        </li>
        <li><RouterLink :to="staticPage.paths.accessibility" tabindex="0">Saavutettavuusseloste</RouterLink></li>
        <li><RouterLink :to="staticPage.paths.about" tabindex="0">Tietoa OP Kodista</RouterLink></li>
        <li><RouterLink :to="staticPage.paths.listing" tabindex="0">Kohdehakuluettelo</RouterLink></li>
        <li><RouterLink :to="staticPage.paths.pricing" tabindex="0">Palveluhinnasto</RouterLink></li>
        <li>
          <RouterLink :to="staticPage.paths.cookies" tabindex="0">Evästeet ja verkkotunnisteiden käyttö</RouterLink>
        </li>
        <li><RouterLink :to="responsibilityProgram.path" tabindex="0">Vastuullisuusohjelma</RouterLink></li>
      </ul>
      <ul class="footer-column" :aria-labelledby="'footer-heading-yhteystiedot'">
        <li><h3 id="footer-heading-yhteystiedot">Yhteystiedot</h3></li>
        <li><RouterLink :to="contactPage.path" tabindex="0">Ota yhteyttä OP Kotiin</RouterLink></li>
        <li><RouterLink :to="careers.path" tabindex="0">Avoimet työpaikat</RouterLink></li>
        <li><RouterLink :to="staticPage.paths.media" tabindex="0">Medialle</RouterLink></li>
        <li><a href="mailto:opkoti@op.fi" tabindex="0">Anna palautetta sivustosta</a></li>
      </ul>
      <div class="copyright">
        <span>&copy; {{ new Date().getFullYear() }} OP Ryhmä</span>
        <span>OP Koti -verkkopalvelun tarjoaa OP Osuuskunta.</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import config from '@/config';
import {
  search,
  staticPage,
  contactPage,
  agencies,
  careers,
  liekkiSellersService,
  responsibilityProgram,
} from '@/app/routes';
import useSafeRoute from '@/app/composables/useSafeRoute';

export default defineComponent({
  name: 'footer-bar',
  setup() {
    const route = useSafeRoute();
    return { route };
  },
  data: () => ({
    config,
    search,
    staticPage,
    contactPage,
    agencies,
    careers,
    liekkiSellersService,
    responsibilityProgram,
  }),
  computed: {
    apartments() {
      return search.sale.routes.find((route) => route.id === config.testing.NAVIGATION.BUYING.APARTMENTS)?.path ?? '';
    },
  },
});
</script>
